import { ProductsPage } from "../../pages/products";

export const routeProducts = "/products";
export const routeProductsById = "/products/:productId";

export const productsRoutes = [
	{
		path: routeProducts,
		element: <ProductsPage />,
	},
	{
		path: routeProductsById,
		element: <ProductsPage />,
	},
];
